<div class="outer-wrapper">
  <div class="app-container">
    <app-search-bar></app-search-bar>
    <router-outlet></router-outlet>
  </div>
</div>
